import React from "react";
import { Link } from "react-router-dom";

import { NetworkBackground } from "./app/components/NetworkBackground";

export default function UnauthAccess({ status = null }) {
  return (
    <div className="grid h-screen w-screen content-center justify-center">
      <div className="mb-56 grid content-center rounded-xl border border-2 border-gray-800 bg-gray-200 shadow-inner">
        <NetworkBackground />
        <h1 className="p-8 text-center text-2xl">This page does not exist</h1>
        <br />
        <Link
          to={`/dashboard`}
          className="center p-8 text-2xl text-purple-800 underline hover:text-black"
        >
          Return to dashboard
        </Link>
      </div>
    </div>
  );
}
